var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdFront = function SvgIdFront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ID_Front_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ID_Front_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -15,
    y: -8.334,
    width: 50,
    height: 55,
    rx: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 61.667,
    cy: 66.666,
    r: 20,
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 16.667,
    y: 14.166,
    width: 66.667,
    height: 51.667,
    rx: 3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 17.166a3 3 0 0 1 3-3h60.666a3 3 0 0 1 3 3v39a3 3 0 0 1-3 3H19.667a3 3 0 0 1-3-3v-39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 25,
    y: 24.166,
    width: 20,
    height: 23.333,
    rx: 1,
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.333 27.5h30M53.333 35.833h28.334M53.333 42.5h20",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgIdFront;